import React, { useContext } from 'react';

import { AnimatePresence } from 'framer-motion';
import { ThemeContext } from 'styled-components';

import YatAnimatedOutline from '@pkg/components/Sections/Profile/AnimatedOutline';

import { Blur, Orbs, PreviewWrapper } from './styles';

interface Props {
    className?: string;
    show: boolean;
    delayShow?: boolean;
    hasExitAnimation?: boolean;
}

const YatPreview = ({ className, show, delayShow, hasExitAnimation = true }: Props) => {
    const theme = useContext(ThemeContext);

    return (
        <AnimatePresence>
            {show && (
                <PreviewWrapper
                    className={className}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={hasExitAnimation ? { opacity: 0 } : undefined}
                    transition={{
                        delay: delayShow ? theme.transitions.speeds.normal : 0,
                        duration: theme.transitions.speeds.normal,
                        ease: theme.transitions.eases.cubic,
                    }}
                >
                    <Blur />
                    <Orbs />

                    <YatAnimatedOutline
                        show
                        primaryColor={theme.colors.purple}
                        secondaryColor={theme.colors.purple}
                        baseColor={theme.shades.purple[50]}
                        dashed
                    />
                </PreviewWrapper>
            )}
        </AnimatePresence>
    );
};

export default YatPreview;
